import React, { useEffect } from "react";
import { loadGTM, removeGTM } from "../utils/gtm";
import { GTM_ID } from "../constants/gtm";
import { COOKIE_KEYS } from "../constants/cookieKeys";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

function GTMManager() {
  useEffect(() => {
    const analyticsConsent = getCookie(COOKIE_KEYS.ANALYTICS) === "true";
    if (analyticsConsent) {
      loadGTM(GTM_ID);
    } else {
      removeGTM(GTM_ID);
    }
  }, []);

  return null; // This component only runs side-effects
}

export default GTMManager;
